import { apiClient } from '../config/apiConfig';
import { log } from '../utils/errors/logger';

/**
 * Service for retrieving application version information
 */
class VersionService {
  /**
   * Get application version information
   * @returns {Promise<Object>} Version information with api and web versions
   */
  async getVersionInfo() {
    try {
      // Get API version from backend
      const apiVersionResponse = await apiClient.getVersionApiVersionGet();
      const versionData = apiVersionResponse.data || {};

      // Get web version from the version.json file (created during Docker build)
      let webVersion: { version: string; build_date?: string; commit?: string } = { version: '1.0.0' };
      try {
        const webVersionResponse = await fetch('/version.json');
        if (webVersionResponse.ok) {
          // Check content type to ensure we're getting JSON
          const contentType = webVersionResponse.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            webVersion = await webVersionResponse.json();
          } else {
            log.warn('version.json returned non-JSON content type', { contentType });
          }
        } else {
          log.warn('Could not load version.json', { status: webVersionResponse.status });
        }
      } catch (error) {
        log.warn('Could not load web version information', { error });
      }
      
      return {
        api: (versionData as any).api || '1.0.0',
        web: webVersion.version || '1.0.0',
        build_date: webVersion.build_date || (versionData as any).build_date || 'unknown',
        git_commit: webVersion.git_commit || (versionData as any).git_commit || 'unknown'
      };
    } catch (error) {
      log.error('Error fetching version information', { error });
      return {
        api: '1.0.0',
        web: '1.0.0',
        build_date: 'unknown',
        git_commit: 'unknown'
      };
    }
  }
}

// Create an instance of the service
const versionService = new VersionService();

// Export the instance as default
export default versionService;
